export default "__VITE_ASSET__3nWmTpLq__"